import { useModals } from "../../../hooks/modals.jsx";

export default function TermsAndConditionModal({
  cancelButtonAction,
  cancelButtonText,
  message,
}) {
  const { toggleTermsAndConditionModal } = useModals();

  return (
    <>
      {toggleTermsAndConditionModal.state && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(14, 14, 14, 0.2)",
            paddingBlockStart: "2rem",
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              pointerEvents: "auto",
              backgroundColor: "#fff",
              backgroundClip: "padding-box",
              border: "1px solid rgba(0,0,0,.2)",
              borderRadius: "8px",
              padding: "1.5rem",
              maxWidth: "800px",
              width: "90%",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <button
              style={{
                fontWeight: 600,
                lineHeight: 1.5,
                textAlign: "center",
                fontSize: "1rem",
                borderRadius: "0.25rem",
                color: "#ffffff",
                backgroundColor: "#01627d",
                height: "58px",
                padding: "0 1.5rem",
                border: "2px solid #014a5f",
                cursor: "pointer", //
                transition: "background 0.3s ease-in-out, border-color 0.3s ease-in-out",
              }}            
              onClick={() => {
                cancelButtonAction?.();
                toggleTermsAndConditionModal.toggle();
              }}
            >
              {cancelButtonText}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
